import {ISlide} from '../../../../incase-domain/slide';
import {IQuestionElements} from '../../../../incase-domain/elements/question';
import {ISlidePreview} from '../../../../incase-domain/proptypes/slidePreview';
import {RuleOperator, RuleResultType} from '../../../../incase-domain/appliedRules';

export const RULE_TYPE_MODIFIER: Record<RuleResultType, string> = {
    [RuleResultType.JUMP_TO_SLIDE]: 'jump',
    [RuleResultType.HIDE_SLIDES]: 'hide',
    [RuleResultType.SHOW_SLIDES]: 'show',
    [RuleResultType.BLOCK_SLIDE]: 'block',
};

export interface SlideNodeData {
    slide: ISlide;
    preview?: ISlidePreview;
}

export interface QuestionNodeData {
    element: IQuestionElements;
    slideId: string;
}

export interface ActionNodeData {
    ruleType: RuleResultType;
    slideIds: string[];
    operator: RuleOperator;
    onChangeType: (type: RuleResultType) => void;
    onAddSlide: (slideId: string) => void;
    onRemoveSlide: (slideId: string) => void;
}
